interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ children, className = '', onClick }) => {
  return (
    <div
      className={`rounded-xl p-4 ${onClick ? 'cursor-pointer active:opacity-80' : ''} ${className}`}
      style={{
        backgroundColor: 'var(--bg-secondary)',
        boxShadow: 'var(--card-shadow)',
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
